module.exports = __webpack_public_path__ + "img/icon-link.8cbbd4fa.svg";